// extracted by mini-css-extract-plugin
export var fullHeightState = "_5o-7";
export var headerCell = "_5o-1";
export var loadingStateCell = "_5o-4";
export var rowWrapper = "_5o-3";
export var standaloneTable = "_5o-8";
export var standaloneTableWithBodyFill = "_5o-9";
export var stateCell = "_5o-5";
export var table = "_5o-0";
export var tableBodyFiller = "_5o-6";
export var white = "_5o-2";